/** The one-time question before new pictures: shots ask for something their approved place does not have (#76). */
export type InventoryAnswer = "make" | "fix" | null;
export interface InventoryShot {
  position: number;
  element: string;
  location: string;
}

export function askAboutInventory(shots: InventoryShot[], doc: Document = document): Promise<InventoryAnswer> {
  return new Promise((resolve) => {
    const dialog = doc.createElement("dialog");
    dialog.className = "confirm-dialog inventory-question";
    dialog.setAttribute("aria-labelledby", "inventory-question-title");
    const count = new Set(shots.map((shot) => shot.position)).size;
    const title = doc.createElement("h2");
    title.id = "inventory-question-title";
    title.textContent = `${count} ${count === 1 ? "shot asks" : "shots ask"} for something their place does not have`;
    const text = doc.createElement("p");
    text.textContent = `${shots.map((shot) => `shot ${shot.position} (${shot.element})`).join(", ")}. `
      + "Made anyway, the approved place wins: the picture shows the place as it is.";
    const actions = doc.createElement("div");
    actions.className = "actions";
    const finish = (answer: InventoryAnswer) => {
      if (typeof dialog.close === "function" && dialog.open) dialog.close();
      dialog.remove();
      resolve(answer);
    };
    for (const [label, answer, primary] of [
      ["Cancel", null, false],
      ["Make anyway", "make", false],
      ["Fix first", "fix", true],
    ] as const) {
      const button = doc.createElement("button");
      button.type = "button";
      button.textContent = label;
      if (primary) button.className = "primary";
      button.addEventListener("click", () => finish(answer));
      actions.append(button);
    }
    dialog.addEventListener("cancel", (event) => {
      event.preventDefault();
      finish(null);
    });
    dialog.append(title, text, actions);
    doc.body.append(dialog);
    if (typeof dialog.showModal === "function") dialog.showModal();
    else dialog.setAttribute("open", "");
  });
}
